'use client'

import React, { useMemo } from 'react'
import dynamic from 'next/dynamic'

import Highcharts from 'highcharts'
import HighchartsExporting from 'highcharts/modules/exporting'
import HighchartsData from 'highcharts/modules/data'
import { HighchartsReactProps } from 'highcharts-react-official'

interface ChartProps extends HighchartsReactProps {
	customStyle?: React.CSSProperties
	className?: string
}

if (typeof Highcharts === 'object') {
	HighchartsExporting(Highcharts)
	HighchartsData(Highcharts)
}

const HighchartsReactNoSSR = dynamic(
	() => import('highcharts-react-official').then((module) => module.HighchartsReact),
	{
		ssr: false,
		loading() {
			return null
		},
	},
)

const areEqual = (prevProps: ChartProps, nextProps: ChartProps) => {
	return JSON.stringify(prevProps.options) === JSON.stringify(nextProps.options)
}

export const Chart = React.memo(({ options, ...rest }: ChartProps) => {
	const mergedOptions = useMemo(
		() => ({
			legend: { enabled: false },
			exporting: { enabled: false },
			credits: { enabled: false },
			accessibility: { enabled: false },
			...options,
		}),
		[options],
	)

	return <HighchartsReactNoSSR highcharts={Highcharts} options={mergedOptions} {...rest} />
}, areEqual)
